export {default} from './ShowEventDetail.js';